<template>
  <div id="">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Quản lý Công nợ', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="buser" class="soft-control">
        <date-range title="Quản lý công nợ" v-model="daterange" class="mx-1"></date-range>
        <div class="ml-2 mr-2">
          <hr />
          <b-row>
            <b-col>
              <b-button block v-b-toggle.advSearch variant="primary">
                <i class="fa fa-binoculars"></i> Tìm kiếm nâng cao
              </b-button>
            </b-col>
            <b-col>
              <b-button @click="printDebt" block variant="success"> <i class="fa fa-print"></i> In toàn bộ </b-button>
            </b-col>
            <b-col>
              <download-excel
                class="btn btn-primary btn-block"
                :data="debtTables"
                :fields="debtFields"
                :worksheet="worksheet"
                name="cong-no.xls"
              >
                <i class="fa fa-file-export"></i>
                Xuất file Excel
              </download-excel>
            </b-col>
            <b-col>
              <b-button variant="info" @click="exportALL()">
                Xuất chi tiết tất cả công nợ
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse id="advSearch" class="mt-2">
                <b-card>
                  <b-row>
                    <b-col md="4">
                      <base-input v-model="searcAdv.search" label="Từ khóa"> </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-select v-model="searcAdv.customer" label="Khách hàng" :ajaxData="getCustomer">
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="4">
                      <base-select label="Người phụ trách" v-model="searcAdv.user" :ajaxData="getUser">
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div class="d-flex">
                            <span class="avatar avatar-sm rounded-circle mr-2">
                              <img
                                v-holder="{
                                  img: '40x40',
                                  text: item.name
                                }"
                                @error="$imgHolder"
                                :alt="item.name"
                                :src="$mediaURI + item.avatar"
                              />
                            </span>
                            <div>
                              <strong>{{ item.name }}</strong>
                              <br />
                              <span>{{ item.phone }}</span>
                            </div>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="12">
                      <hr />
                      <b-button @click="fetchData" block variant="secondary ">
                        <i class="fa fa-search"></i> Tìm kiếm</b-button
                      >
                    </b-col>
                  </b-row>
                </b-card>
              </b-collapse>
            </b-col>
          </b-row>
        </div>
        <template v-if="debts.length > 0">
          <b-card class="mb-3 m-2" no-body v-for="(debtItem, index) in debts" :key="index">
            <b-card-header header-tag="header" class="p-1 d-flex justify-content-between align-items-center">
              <b-button variant="link" href="#" v-b-toggle="debtItem.key">
                <span>{{ debtItem.month }}</span>
              </b-button>
            </b-card-header>
            <b-collapse visible :id="debtItem.key">
              <b-card-body class="px-2">
                <div class="timeline timeline-one-side" data-timeline-content="axis" data-timeline-axis-style="dashed">
                  <div v-for="(item, index) in debtItem.customers" :key="index" class="timeline-block">
                    <span class="timeline-step badge-success">
                      <span class="avatar avatar-sm rounded-circle">
                        <img
                          v-holder="{
                            img: '40x40',
                            text: item.info.name
                          }"
                          @error="$imgHolder"
                          :alt="item.info.name"
                          :src="$mediaURI + item.info.avatar"
                        />
                      </span>
                    </span>
                    <div class="timeline-content" style="width:auto; max-width:unset">
                      <h5 class="mb-2">
                        {{ item.info.code }} - {{ item.info.name }} - Người phụ trách : {{ item.info.userManage.name }}
                      </h5>
                      <template v-for="(cur, i) in item.currencys">
                        <div
                          style="min-height: 95px; margin-bottom:20px"
                          class="table-responsive base-table table-soft b-table-sticky-header"
                        >
                          <b-table
                            :filter="cur"
                            :filter-function="filterTable"
                            small
                            :fields="fields"
                            :items="item.data"
                            responsive="sm"
                          >
                            <template v-slot:cell(dateCreated)="{ value }">
                              {{ $dateTimeUnix(value) }}
                            </template>
                            <template v-slot:cell(userCreated)="{ item }">
                              {{ item.userCreated.name }}
                            </template>
                            <template v-slot:cell(total)="{ item }">
                              {{ $formatNumber(item.total) }}
                              {{ item.currency }}
                            </template>
                            <template v-slot:cell(totalAmout)="{ item }">
                              {{ $formatNumber(item.totalAmout) }}
                              {{ item.currency }}
                            </template>
                            <template v-slot:cell(paid)="{ item }">
                              {{ $formatNumber(item.paid) }}
                              {{ item.currency }}
                            </template>
                            <template v-slot:cell(totalReturn)="row">
                              <b-button @click="row.toggleDetails" variant="link">
                                {{ $formatNumber(row.item.totalReturn) }}
                                {{ row.item.currency }}
                              </b-button>
                            </template>
                            <template v-slot:row-details="{ item }">
                              <div class="p-3">
                                <h4>Lịch sử trả hàng</h4>
                                <table
                                  class="table tablesorter b-table b-table-no-border-collapse b-table-selectable b-table-select-range b-table-selecting"
                                >
                                  <thead>
                                    <tr>
                                      <th>STT</th>
                                      <th>Ngày tạo</th>
                                      <th class="text-left">Người Tạo phiếu</th>
                                      <th class="text-right">Số lượng</th>
                                      <th class="text-right">Đơn giá</th>
                                      <th class="text-right">Thành tiền</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(row, index) in item.receiptBillReturn" :key="index">
                                      <td class="bg-info text-light col-fix ">
                                        {{ index + 1 }}
                                      </td>
                                      <td class="text-left">
                                        {{ $dateUnix(row.dateCreated) }}
                                      </td>
                                      <td class="text-left">
                                        {{ row.userCreated.name }}
                                      </td>
                                      <td class="text-right">
                                        {{ $formatNumber(row.quantity) }}
                                      </td>
                                      <td class="text-right">
                                        {{ $formatNumber(row.price) }}
                                        {{ cur.currency }}
                                      </td>
                                      <td class="text-right">
                                        {{ $formatNumber(row.quantity * row.price) }}
                                        {{ cur.currency }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </template>
                            <template v-slot:cell(remain)="{ item }">
                              <span v-if="item.totalAmout > 0">
                                {{ $formatNumber(item.totalAmout - item.totalReturn - item.paid) }}
                              </span>
                              <span v-else>
                                {{ $formatNumber(item.total - item.totalReturn - item.paid) }}
                              </span>
                              {{ item.currency }}
                            </template>
                            <template v-slot:custom-foot="">
                              <b-tr>
                                <b-th colspan="3">
                                  Tổng cộng
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  {{ $formatNumber(cur.summarry.total) }}
                                  {{ cur.currency }}
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  {{ $formatNumber(cur.summarry.totalAmout) }}
                                  {{ cur.currency }}
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  {{ $formatNumber(cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  {{ $formatNumber(cur.summarry.totalReturn) }}
                                  {{ cur.currency }}
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  <span v-if="cur.summarry.totalAmout > 0">
                                    {{
                                      $formatNumber(
                                        cur.summarry.totalAmout - cur.summarry.totalReturn - cur.summarry.paid
                                      )
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      $formatNumber(cur.summarry.total - cur.summarry.totalReturn - cur.summarry.paid)
                                    }}
                                  </span>
                                  {{ cur.currency }}
                                </b-th>
                                <b-th></b-th>
                              </b-tr>
                            </template>
                            <b-tfoot>
                              <b-tr>
                                <b-td colspan="4">Tổng cộng</b-td>
                                <b-td class="text-right">
                                  {{ $formatNumber(cur.summarry.total) }}
                                  {{ cur.currency }}
                                </b-td>
                                <b-td class="text-right">
                                  {{ $formatNumber(cur.summarry.totalAmout) }}
                                  {{ cur.currency }}
                                </b-td>
                                <b-td class="text-right">
                                  {{ $formatNumber(cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </b-td>
                                <b-td class="text-right">
                                  {{ $formatNumber(cur.summarry.total - cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </b-td>
                              </b-tr>
                            </b-tfoot>
                          </b-table>

                          <!-- <table
                            class="table tablesorter b-table b-table-no-border-collapse b-table-selectable b-table-select-range b-table-selecting"
                          >
                            <thead>
                              <tr>
                                <th>STT</th>
                                <th>Ngày tạo</th>
                                <th class="text-left">Mã Phiếu xuất</th>
                                <th class="text-left">Người Tạo phiếu</th>
                                <th class="text-right">Tổng tiền</th>
                                <th class="text-right">Đã thanh toán</th>
                                <th class="text-right">Còn lại</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row, index) in item.data"
                                :key="index"
                              >
                                <template v-if="row.currency == cur.currency">
                                  <td class="bg-info text-light col-fix ">
                                    {{ index + 1 }}
                                  </td>
                                  <td class="text-left">
                                    {{ $dateUnix(row.dateCreated) }}
                                  </td>
                                  <td class="text-left">{{ row.code }}</td>
                                  <td class="text-left">
                                    {{ row.userCreated.name }}
                                  </td>
                                  <td class="text-right">
                                    {{ $formatNumber(row.total) }}
                                    {{ cur.currency }}
                                  </td>
                                  <td class="text-right">
                                    {{ $formatNumber(row.paid) }}
                                    {{ cur.currency }}
                                  </td>
                                  <td class="text-right">
                                    {{ $formatNumber(row.total - row.paid) }}
                                    {{ cur.currency }}
                                  </td>
                                </template>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colspan="4">Tổng cộng</td>
                                <td class="text-right">
                                  {{ $formatNumber(cur.summarry.total) }}
                                  {{ cur.currency }}
                                </td>
                                <td class="text-right">
                                  {{ $formatNumber(cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </td>
                                <td class="text-right">
                                  {{
                                    $formatNumber(
                                      cur.summarry.total - cur.summarry.paid
                                    )
                                  }}
                                  {{ cur.currency }}
                                </td>
                              </tr>
                            </tfoot>
                          </table> -->
                        </div>
                      </template>
                    </div>
                    <div>
                      <b-button variant="info" @click="renderExecl(item, debtItem)">
                        Xuất công nợ
                      </b-button>
                      <span>{{ item.info.fax }}</span>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </template>
        <b-card v-else class="m-2">
          <h4>Chưa có công nợ nào trong khoản thời gian này</h4>
        </b-card>
      </block>
    </div>
    <preview ref="preview"></preview>
  </div>
</template>
<script>
import { receiptService, userService, customerService } from '@/_services';
import { addDateTime, formatDateUnix } from '@/utils/date';
import JsonExcel from 'vue-json-excel';

import XLSX from 'xlsx';
import invoiceTemplate from '../../template/excel/invoice';

import { mapState } from 'vuex';

import Preview from './__Preview';
export default {
  name: 'debt-manage',
  components: {
    Preview,
    downloadExcel: JsonExcel
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        from: addDateTime(-3),
        to: new Date()
      },
      searcAdv: {
        search: '',
        customer: '',
        user: ''
      },
      daterange: {},
      debtTables: [],
      worksheet: 'Công nợ',
      debtFields: {
        STT: 'stt',
        'Mã khách hàng': 'customer.code',
        'Tên khách hàng': 'customer.name',
        'Mã phiếu xuất': 'code',
        'Người tạo phiếu': 'userCreated.name',
        'Tổng tiền': 'total',
        'Đã thanh toán': 'paid',
        'Đã trả hàng': 'totalReturn',
        'Còn lại': {
          callback: value => {
            if (value.totalAmout > 0) return `${value.totalAmout - value.paid - value.totalReturn}`;
            else return `${value.total - value.paid - value.totalReturn}`;
          }
        },
        'Loại tiền': 'currency',
        'Ngày tạo': {
          callback: value => {
            return this.$dateUnix(value.dateCreated);
          }
        }
      },
      lastIndexCustomerSelected: 0,
      debts: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          label: 'STT',
          class: 'col-fix checkbox'
        },
        {
          key: 'code',
          label: 'Mã phiếu xuất',
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'userCreated',
          label: 'Người tạo phiếu',
          sortable: true,
          class: ''
        },
        {
          key: 'total',
          label: 'Tổng tiền',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'totalAmout',
          label: 'Tổng tiền sau thuế',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'paid',
          label: 'Đã thanh toán',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'totalReturn',
          label: 'Tiền hàng trả lại',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'remain',
          label: 'Còn lại',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'dateCreated',
          label: 'Ngày tạo',
          sortable: true,
          class: 'col-fix'
        }
      ],
      allCurrency: [],
      excelData: {
        cols: [
          { name: 'A', key: 0 },
          { name: 'B', key: 1 },
          { name: 'C', key: 2 }
        ],
        data: [
          ['', 'name', 'value'],
          [1, 'sheetjs', 7262],
          [2, 'js-xlsx', 6969]
        ]
      }
    };
  },
  computed: {
    ...mapState('user', ['info'])
  },
  methods: {
    renderExecl(item, debtItem) {
      let fileName = 'CONGNO_' + formatDateUnix(debtItem.date, 'MMYYYY') + '_' + item.info.code;
      var new_workbook = XLSX.utils.book_new();
      new_workbook.Props = {
        Title: 'CÔNG NỢ - ' + item.info.name,
        Subject: 'CÔNG NỢ',
        Author: 'ERP ĐAI MI',
        CreatedDate: new Date(2021, 12, 19)
      };
      let order = {};
      let date = '';
      // debugger;
      if (item.data.length > 0) {
        order = item.data[0].order;
        date = formatDateUnix(order.dateUpdated, 'DD/MM/YYYY');
      }
      let buyer = 'BUYER : ' + item.info.name;
      let buyerAddress = item.info.address;
      let invoiceNo = order.code;
      let to = 'TO ' + item.info.name;

      let worksheet = invoiceTemplate.init(buyer, buyerAddress, invoiceNo, date, to);
      // var worksheet = XLSX.utils.aoa_to_sheet(invoiceTemplate.data());

      XLSX.utils.book_append_sheet(new_workbook, worksheet, fileName);
      let listInvoice = item.data;
      let arrData = [];
      for (let i = 0; i < listInvoice.length; i++) {
        const ele = listInvoice[i];
        //let ReceiptBillDetail = {};
        if (ele.ReceiptBillDetail.length > 0) {
          for (let j = 0; j < ele.ReceiptBillDetail.length; j++) {
            const ReceiptBillDetail = ele.ReceiptBillDetail[j];
            // ReceiptBillDetail = ele.ReceiptBillDetail[0];
            let Product = ReceiptBillDetail.Product;
            let ProductInfo = ReceiptBillDetail.ProductInfo;
            let ProductSpecify = ReceiptBillDetail.ProductSpecify;
            arrData.push([
              formatDateUnix(ele.dateCreated, 'DD/MM/YYYY'),
              ele.code,

              /*ReceiptBillDetail.productCustom && ReceiptBillDetail.productCustom.length > 0
                ? Product.name + ' - ' + ReceiptBillDetail.productCustom
                : Product.name,*/
              ReceiptBillDetail.reason ? Product.name + ' - ' + ReceiptBillDetail.reason.name : Product.name,
              Product.code,
              ProductInfo.colorText,
              ProductInfo.colorCode1,
              ProductSpecify.name,
              'mm',
              ReceiptBillDetail.length + ' cm',
              ReceiptBillDetail.quantity,
              ReceiptBillDetail.unit,
              ReceiptBillDetail.price,

              ReceiptBillDetail.total,
              ReceiptBillDetail.currency,
              ele.order.code,
              ele.order.receiver.short_name,
              ele.customer.customerContact.name,
              ele.order.poCode
            ]);
          }
        }
      }
      console.log(formatDateUnix(arrData));
      // // this.add_cell_to_sheet(worksheet, "D5", 10);

      XLSX.utils.sheet_add_aoa(worksheet, arrData, { origin: -1 });

      // XLSX.writeFile(new_workbook, "hoho.xlsx");

      // XLSX.utils.sheet_add_aoa(new_workbook["SheetJS"], this.excelData.data, {
      //   origin: -1
      // });
      XLSX.writeFile(new_workbook, fileName + '.xlsx');
      //var wbout = XLSX.write(new_workbook, {bookType:'xlsx',  type: 'binary'});
    },
    add_cell_to_sheet(worksheet, address, value) {
      /* cell object */
      var cell = { t: '?', v: value };

      /* assign type */
      if (typeof value == 'string') cell.t = 's';
      // string
      else if (typeof value == 'number') cell.t = 'n';
      // number
      else if (value === true || value === false) cell.t = 'b';
      // boolean
      else if (value instanceof Date) cell.t = 'd';
      else throw new Error('cannot store value');

      /* add to worksheet, overwriting a cell if it exists */
      worksheet[address] = cell;

      /* find the cell range */
      var range = XLSX.utils.decode_range(worksheet['!ref']);
      var addr = XLSX.utils.decode_cell(address);

      /* extend the range to include the new cell */
      if (range.s.c > addr.c) range.s.c = addr.c;
      if (range.s.r > addr.r) range.s.r = addr.r;
      if (range.e.c < addr.c) range.e.c = addr.c;
      if (range.e.r < addr.r) range.e.r = addr.r;

      /* update range */
      worksheet['!ref'] = XLSX.utils.encode_range(range);
    },
    fetchData() {
      this.listQuery.from = this.daterange.from;
      this.listQuery.to = this.daterange.to;
      if (this.searcAdv.user) {
        this.listQuery.userId = this.searcAdv.user.id;
      } else {
        this.listQuery.userId = '';
      }
      if (this.searcAdv.customer) {
        this.listQuery.customerId = this.searcAdv.customer.id;
      } else {
        this.listQuery.customerId = '';
      }

      this.listQuery.search = this.searcAdv.search;

      this.worksheet = `${this.$date(this.daterange.from, 'DD_MM_YYYY')} - ${this.$date(
        this.daterange.to,
        'DD_MM_YYYY'
      )}`;
      this.allCurrency = [];
      receiptService.debt(this.listQuery).then(res => {
        let receipts = res.data.data;
        this.debtTables = [];
        let debt = [];
        let stt = 1;
        receipts.forEach(element => {
          let code = element.customer.code;
          let month = formatDateUnix(element.dateCreated, 'MM_YYYY');

          // let ReceiptBillDetail = element.ReceiptBillDetail;
          // let totalBillReturn = 0;
          // ReceiptBillDetail.forEach(billDetail => {
          //   let receiptBillReturn = billDetail.receiptBillReturn;
          //   let totalReturn = 0;

          //   if (receiptBillReturn.length > 0) {
          //     receiptBillReturn.forEach(billReturn => {
          //       totalReturn += billReturn.price * billReturn.quantity;
          //     });
          //   }
          //   billDetail.totalReturn = totalReturn;
          //   totalBillReturn += totalReturn;
          // });
          // element.totalReturn = totalBillReturn;

          let receiptBillReturn = element.receiptBillReturn;
          let totalReturn = 0;

          if (receiptBillReturn.length > 0) {
            receiptBillReturn.forEach(billReturn => {
              totalReturn += billReturn.price * billReturn.quantity;
            });
          }
          element.totalReturn = totalReturn;

          this.allCurrency[element.currency] = element.currency;
          if (debt[month] && debt[month].customers) {
            /// kiểm tra đã đưa tháng này vào mảng chưa
            let customers = debt[month].customers;

            if (customers[code] && customers[code].data) {
              // kiểm tra đã đưa khách hàng này vào mảng tháng hay chưa
              customers[code].data.push(element);
              // if (!customers[code].currencys.includes(element.currency)) {
              let currency = this.checkItemInArray(customers[code].currencys, element.currency, 'currency');
              if (!currency || currency == false) {
                // kiểm tra loại tiền khách hàng sử dụng đã đc nạp vào mảng hay ch
                //if (!customers[code].currencys[element.currency]) {
                let currencySummarry = {
                  currency: element.currency,
                  summarry: {
                    total: element.total,
                    totalAmout: element.totalAmout > element.total ? element.totalAmout : element.total,
                    paid: element.paid,
                    totalReturn: element.totalReturn
                  }
                };
                customers[code].currencys.push(currencySummarry);
                //customers[code].currencys.push(element.currency);
              } else {
                currency.summarry.total += element.total;
                currency.summarry.totalAmout += element.totalAmout;
                currency.summarry.paid += element.paid;
                currency.summarry.totalReturn += element.totalReturn;
              }
            } else {
              //let customers = [];
              let currencySummarry = {
                currency: element.currency,
                summarry: {
                  total: element.total,
                  totalAmout: element.totalAmout > element.total ? element.totalAmout : element.total,
                  paid: element.paid,
                  totalReturn: element.totalReturn
                }
              };

              customers[code] = {
                info: element.customer,
                code: code,
                data: [element],
                currencys: [currencySummarry]
                //currencys: [element.currency]
              };
            }
            // debt[month].data.push(element);
          } else {
            let customers = [];
            let currencySummarry = {
              currency: element.currency,
              summarry: {
                total: element.total,
                totalAmout: element.totalAmout > element.total ? element.totalAmout : element.total,
                paid: element.paid,
                totalReturn: element.totalReturn
              }
            };

            customers[code] = {
              info: element.customer,
              code: code,
              data: [element],
              currencys: [currencySummarry]
              //currencys: [element.currency]
            };
            debt[month] = {
              customers: customers,
              key: month,
              date: element.dateCreated,
              month: formatDateUnix(element.dateCreated, 'MM/YYYY')
            };
          }
          element.stt = stt;
          stt++;
          this.debtTables.push(element);
        });
        this.debts = Object.values(debt);
        this.debts.forEach(element => {
          element.customers = Object.values(element.customers);
        });
        console.log(this.debts, this.allCurrency);
      });
    },
    exportALL() {
      let fileName = 'CONGNO_' + formatDateUnix(this.listQuery.from, 'MMYYYY');
      var new_workbook = XLSX.utils.book_new();

      let arrData = [];
      for (let i = 0; i < this.debts.length; i++) {
        const debtItem = this.debts[i];

        if (debtItem.customers.length > 0) {
          for (let j = 0; j < debtItem.customers.length; j++) {
            const item = debtItem.customers[j];
            let listInvoice = item.data;
            let info = item.info;
            for (let i = 0; i < listInvoice.length; i++) {
              const ele = listInvoice[i];
              if (ele.ReceiptBillDetail.length > 0) {
                for (let j = 0; j < ele.ReceiptBillDetail.length; j++) {
                  const ReceiptBillDetail = ele.ReceiptBillDetail[j];
                  // ReceiptBillDetail = ele.ReceiptBillDetail[0];
                  let Product = ReceiptBillDetail.Product;
                  let ProductInfo = ReceiptBillDetail.ProductInfo;
                  let ProductSpecify = ReceiptBillDetail.ProductSpecify;
                  arrData.push([
                    info.code,
                    info.name,
                    formatDateUnix(ele.dateCreated, 'DD/MM/YYYY'),
                    ele.code,

                    /*ReceiptBillDetail.productCustom && ReceiptBillDetail.productCustom.length > 0
                        ? Product.name + ' - ' + ReceiptBillDetail.productCustom
                        : Product.name,*/
                    ReceiptBillDetail.reason ? Product.name + ' - ' + ReceiptBillDetail.reason.name : Product.name,
                    Product.code,
                    ProductInfo.colorText,
                    ProductInfo.colorCode1,
                    ProductSpecify.name,
                    'mm',
                    ReceiptBillDetail.length + ' cm',
                    ReceiptBillDetail.quantity,
                    ReceiptBillDetail.unit,
                    ReceiptBillDetail.price,

                    ReceiptBillDetail.total,
                    ReceiptBillDetail.currency,
                    ele.order.code,
                    ele.order.receiver.short_name,
                    ele.customer.customerContact.name,
                    ele.order.poCode
                  ]);
                }
              }
            }
          }
        }
      }
      var worksheet = XLSX.utils.aoa_to_sheet(arrData);
      XLSX.utils.book_append_sheet(new_workbook, worksheet, fileName);
      XLSX.writeFile(new_workbook, fileName + '.xlsx');
      // IN NÂNG CAO
    },
    filterTable(row, filter) {
      return row.currency == filter.currency;
      // if (this.filter) {
      //   if (row[this.filter.key] == this.filter.value) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // } else {
      //   if (row.active || this.showAll) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }
    },
    checkItemInArray(arr, value, key) {
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if (element[key] == value) {
          return element;
        }
      }
      return false;
    },
    getUser(keyword, cb) {
      userService.adminGetAllUser({ search: keyword }).then(res => {
        let data = res.data.data;
        data.push(this.info);
        data.push({
          id: -1,
          name: 'Tất cả nhân viên'
        });
        cb(data);
      });
    },
    getCustomer(keyword, cb) {
      customerService.findAll({ search: keyword }).then(res => {
        let data = res.data.data;
        data.push({
          id: -1,
          name: 'Tất cả khách hàng'
        });
        cb(data);
      });
    },
    printDebt() {
      this.$refs.preview.visible = true;
      let debt = {
        from: this.daterange.from,
        to: this.daterange.to,
        data: this.debts
      };
      this.$refs.preview.setData(debt);
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log('context menu', a);
    },
    handleUpdate() {},
    handleCreate() {},
    handleCopy() {},
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    }
  },
  watch: {
    daterange: function() {
      this.fetchData();
    }
  }
};
</script>
<style lang="scss"></style>
